import React, { useState, useEffect } from 'react';
import './style/CookieBanner.css';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookie_consent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <p>
        Utilizziamo solo cookie tecnici essenziali al corretto funzionamento del
        sito. Continuando a utilizzare questo sito o cliccando su "Accetta"
        permetti il loro utilizzo. Per maggiori informazioni consulta la nostra{' '}
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        .
      </p>
      <button className="cookie-banner-button" onClick={handleAccept}>
        Accetta
      </button>
    </div>
  );
};

export default CookieBanner;
